<template>
  <component-wrapper
    class="reduced-layout-fi"
    :force-theme="brand"
  >
    <div class="reduced-layout-fi__container">
      <div class="reduced-layout-fi__header">
        <img
          v-if="logoSrc"
          class="reduced-layout-fi__header-icon"
          :src="logoSrc"
          :alt="logoAlt"
        />
      </div>
      <div class="reduced-layout-fi__content-container">
        <div class="reduced-layout-fi__content">
          <grid-container-fi :container="false">
            <template v-if="apiData?.Maintenance_Mode">
              <div class="reduced-layout-fi__maintenance-message">
                <result-status-fi :custom-icon="'alert-triangle'">
                  <richtext-fi :html-content="{ value: apiData.Notification }" />
                </result-status-fi>
              </div>
            </template>
            <template v-else>
              <div
                v-if="apiData?.Notification"
                class="reduced-layout-fi__notification"
              >
                <block-notification-fi
                  icon="alert-triangle"
                  type="error"
                >
                  <richtext-fi :html-content="{ value: apiData.Notification }" />
                </block-notification-fi>
              </div>
              <div class="reduced-layout-fi__page">
                <slot />
              </div>
            </template>
          </grid-container-fi>
        </div>
      </div>
      <div
        v-if="apiData"
        class="reduced-layout-fi__footer"
      >
        <div class="reduced-layout-fi__footer-content">
          <div
            v-if="apiData.Available_Languages?.length"
            class="reduced-layout-fi__language"
          >
            <select-input-fi
              value="interfaceLanguage"
              :name="apiData.Language_Selector_Label"
              :options="
                apiData.Available_Languages.map((pageLang) => ({
                  name: pageLang.Title,
                  value: pageLang.Value,
                }))
              "
              class="reduced-layout-fi__lang-selector"
              transparent
              small
              @change="(evt) => $emit('change-language', evt)"
            />
          </div>
          <span class="reduced-layout-fi__footer-item">{{
            $dict.replace(apiData.Company || '', [new Date().getFullYear()])
          }}</span>
          <link-fi
            v-for="link in apiData.Elements || []"
            :key="link.Id"
            :href="link.Link.Url"
            :target="link.Link.Target"
            :size="14"
            class="reduced-layout-fi__footer-item"
            text-link
            thin
          >
            {{ link.Link.Title || link.Link.Text }}
          </link-fi>
        </div>
      </div>
    </div>
  </component-wrapper>
</template>

<script>
import { LinkFi, RichtextFi, SelectInputFi } from 'atoms';
import ComponentWrapper from 'components/component-wrapper/ComponentWrapper';
import GridContainerFi from 'components/grid-fi/GridContainerFi';
import BlockNotificationFi from 'components/notifications-fi/block-notification-fi/BlockNotificationFi';
import ResultStatusFi from 'components/result-status-fi/ResultStatusFi';

export default {
  name: 'ReducedLayoutFi',
  components: {
    ComponentWrapper,
    GridContainerFi,
    BlockNotificationFi,
    LinkFi,
    SelectInputFi,
    RichtextFi,
    ResultStatusFi,
  },
  props: {
    logoSrc: {
      type: String,
      default: null,
    },
    logoAlt: {
      type: String,
      default: null,
    },
    apiData: {
      type: Object,
      default: null,
    },
    brand: {
      type: String,
      default: null,
    },
    interfaceLanguage: {
      type: String,
      default: null,
    },
  },
  emits: ['change-language'],
};
</script>

<style scoped lang="scss">
@import './reduced-layout-fi';
</style>
